import type { Pinia } from 'pinia';
import { resolveInjected } from '~/utils/nuxt-instance';

/**
 * VUE 2.7 WORKAROUND — DELETE THIS FILE AT THE VUE 3 FLIP.
 *
 * Vue 2.7's native Composition API has a confirmed core bug where inject()
 * checks currentInstance.$parent, which is undefined for the root — this
 * breaks Pinia's own SSR provide/inject path (PiniaVuePlugin only calls
 * setActivePinia() on the client; on the server it relies entirely on
 * inject(), which this bug silently fails). Diagnosed by Pinia's own author:
 * https://github.com/vuejs/vue/issues/12636
 *
 * Vue 3 doesn't have this bug, and @pinia/nuxt handles injection correctly
 * on its own. At the flip:
 *   1. Delete this file.
 *   2. In every store/*.ts file, remove the wrapper function and export
 *      defineStore(...)'s own return value directly, e.g.:
 *        export const useUserStore = defineStore('user', {...});
 *   3. Call sites need no changes — they only ever depended on each store's
 *      exported name, never on how it obtained its Pinia instance.
 */
export function usePinia(): Pinia {
  return resolveInjected('$pinia');
}
